/**
 * Rollup does not support renamed exports so do not change this to export { Controller as InputControl } ...
 */
import { Controller } from 'react-hook-form';

/**
 * @deprecated use the `Controller` component from react-hook-form instead
 */
export const InputControl = Controller;
